export const CREATE_PRODUCT_PANEL = 'CREATE_PRODUCT_PANEL'
export const GET_LIST_PRODUCT_PANEL = 'GET_LIST_PRODUCT_PANEL'
export const DETAIL_PRODUCT_PANEL = 'DETAIL_PRODUCT_PANEL'
export const PATCH_PRODUCT_PANEL = 'PATCH_PRODUCT_PANEL'
